export default __webpack_public_path__ + "static/media/pic5.94f4840b.jpg";